'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionToSentryFingerprint = undefined;

var _errorActionGetters = require('./errorActionGetters');

var actionToSentryFingerprint = exports.actionToSentryFingerprint = function actionToSentryFingerprint(action) {
  var fingerprint = ['{{ default }}', action.type];
  var error = (0, _errorActionGetters.getError)(action);

  fingerprint.push('generic-error-string=' + !(0, _errorActionGetters.getErrorTitle)(action));

  if (error && typeof error.status === 'number') {
    fingerprint.push('' + error.status);
  }

  return fingerprint;
};